'use client'
import { CardActions, CardContent, Card as MuiCard, Skeleton } from '@mui/material'

import React from 'react'
interface CardProps {
  children?: React.ReactNode
  action?: React.ReactNode[] | undefined
  className?: string
  isLoading?: boolean
  cover?: React.ReactNode
  badge?: React.ReactNode[]
  badgePosition?: 'start' | 'end'
  extra?: React.ReactNode
  style?: React.CSSProperties
  onClick?: (this: Window, ev: MouseEvent) => any
  direction?: Direction
}

export const Card = ({
  children,
  action,
  className,
  isLoading,
  cover,
  badgePosition = 'start',
  badge,
  extra,
  style,
  direction,
  onClick,
}: CardProps) => {
  return (
    <div className="flex h-full gap-2">
      <MuiCard
        component={'div'}
        // onClick={onClick}
        style={{ width: '100%', ...style }}
        className={`h-full border border-solid border-[#f0f0f0] transition duration-500 hover:border-primary ${className}`}
      >
        {cover && cover}
        <CardContent className="flex-1">
          {isLoading ? (
            <>
              <Skeleton animation="wave" />
              <Skeleton animation="wave" />
              <Skeleton animation="wave" />
            </>
          ) : (
            children
          )}
        </CardContent>
        {action && <CardActions>{action}</CardActions>}
        {extra && <div className="p-2">{extra}</div>}
        {direction === 'GRID' && badge && (
          <div
            className={`absolute top-5 ${badgePosition === 'start' ? 'left-5' : 'right-5'} flex flex-wrap gap-2`}
          >
            {badge.map((el, index) => (
              <div key={index} className="rounded-sm">
                {el}
              </div>
            ))}
          </div>
        )}
      </MuiCard>
    </div>
  )
}
